// src/components/SchemaMarkup.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

const SchemaMarkup = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebSite", // This schema describes your overall website
    "name": "Jimatly", // Your website name
    "url": "https://www.jimatly.com", // Your website URL
    "potentialAction": { // Describes the search functionality if you have one
      "@type": "SearchAction",
      // Update this URL if your search page/query parameter is different
      "target": "https://www.jimatly.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <Helmet>
      {/* Embed the schema as JSON-LD in a script tag */}
      {/* The type="application/ld+json" is standard */}
      <script type="application/ld+json">
        {/* Convert the JavaScript object to a JSON string */}
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default SchemaMarkup;